export const GLOBAL_MESSAGE_ERROR_CLASS = 'global-message--error';
export const GLOBAL_MESSAGE_SUCCESS_CLASS = 'global-message--success';
export const GLOBAL_MESSAGE_WARNING_CLASS = 'global-message--warning';

export const GLOBAL_MESSAGE_DEFAULT_DURATION = 5000;
export const GLOBAL_MESSAGE_DEFAULT_HORIZONTAL_POSITION = 'right';
export const GLOBAL_MESSAGE_DEFAULT_VERTICAL_POSITION = 'top';
